import React, { createContext } from 'react';

const Context = createContext([false, () => {}]);

export default Context;
